import React, { useEffect, useRef, useState } from "react";
import { useInterviewContext } from "../InterviewContext";
import { useTranslation } from "react-i18next";
import Datetime from "react-datetime";
import { blockRetroactiveDates } from "../../../common/helper";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";
import "../../styles/forms.scss";
import "react-datetime/css/react-datetime.css";
import { PreCandidateService } from "../../../services/PreCandidate";
import Select from "../../../components/Select";

const Availability = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const {
    interview,
    setInterview,
    errors,
    setErrors,
    noticeList,
    availabilityStatus
  } = useInterviewContext();
  const [reasons, setReasons] = useState([]);
  const fixedDateButtonRef = useRef();

  useEffect(() => {
    PreCandidateService.GetReasons().then((reasons) => setReasons(reasons));
  }, []);

  useEffect(() => {
    if(interview.availabilityAndConditions.negotiable === null){
      interview.availabilityAndConditions.negotiable = false; 
    }
  }, []);

  const onChangeAvailability = (event) => {
    let availabilityAndConditions= {...interview.availabilityAndConditions}

    availabilityAndConditions.availabilityId= availabilityStatus.find(
      (status) => status.code === event.target.id
    ).id;
    availabilityAndConditions.availabilityCode=event.target.id;

    if (event.target.id !== "FD") {
      fixedDateButtonRef.current.click();
    }
    if(event.target.id!=="OH")
    {
      availabilityAndConditions.negotiable=false;
      availabilityAndConditions.noticeId= null;
   }
    if(event.target.id!=="UD")
    availabilityAndConditions.availabilityReasonId=null
     setInterview({...interview,availabilityAndConditions:availabilityAndConditions})
  };

  const onChangeIsNegotiable = (event) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      availabilityAndConditions: {
        ...prevInterview.availabilityAndConditions,
        negotiable: event.target.checked
      }
    }));
  };

  const onChangeNotice = (event) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      availabilityAndConditions: {
        ...prevInterview.availabilityAndConditions,
        noticeId: Number(event.target.value)
      }
    }));
  };

  const onChangeFixedDate = (event) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      availabilityAndConditions: {
        ...prevInterview.availabilityAndConditions,
        fixedDate: event._d
      }
    }));
  };

  const getDateValid = (date) => {
    if (date) {
      return new Date(date);
    }
  };
  
  function onChangeAvailabilityResonId({target}){

    let availabilityAndConditions = {...interview.availabilityAndConditions}
    availabilityAndConditions.availabilityReasonId=target.value;
    setInterview({...interview,availabilityAndConditions:availabilityAndConditions})
  }

  return (
    <section className="availability">
      <h1>{t("Availability")}</h1>
      <div className="form-check">
        <div>
          <input
            className="form-check-input"
            type="radio"
            name="availabilityId"
            id="IM"
            checked={
              interview.availabilityAndConditions.availabilityCode === "IM"
            }
            onChange={onChangeAvailability}
          />
          <label htmlFor="IM">{t("Immediate")}</label>
        </div>
        <div>
          <input
            className="form-check-input"
            type="radio"
            name="availabilityId"
            id="UN"
            checked={interview.availabilityAndConditions.availabilityCode === "UN"}
            onChange={onChangeAvailability}
          />
          <label className="form-check-label" htmlFor="UN">
            {t("Unavailable")}
          </label>
          {errors.availabilityReasonId && (
            <span className="error-msg">{errors.availabilityReasonId}</span>
          )}
         </div> 
         <div className="form-group">
          <Select
            id="availabilityReasonId"
            name="availabilityReasonId"
            className="form-select"
            disabled={interview.availabilityAndConditions.availabilityCode !== "UN"}
            onChange={onChangeAvailabilityResonId}
            defaultValue={0}
            required
            title={t("Selecione um item da lista.")}
            style={{ width: "430px" }}
            value={interview.availabilityAndConditions.availabilityReasonId || 0}
          >
            <option key={0} value={0} selected disabled>
              {t("Select Reason...")}
            </option>
            {reasons.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </Select>
        </div>
        <div>
          <input
            className="form-check-input"
            type="radio"
            name="availabilityId"
            id="OH"
            checked={interview.availabilityAndConditions.availabilityCode === "OH"}
            onChange={onChangeAvailability}
          />
          <label className="form-check-label" htmlFor="OH">
            {t("Notice")}
          </label>
          {errors.noticeId && (
            <span className="error-msg">{errors.noticeId}</span>
          )}
        </div>
      </div>

      <div className="negotiable">
      
        <div className="form-group">
          <Select
            id="noticeId"
            name="noticeId"
            style={{ width: "290px" }}
            onChange={onChangeNotice}
            value={interview.availabilityAndConditions.noticeId || "0"}
            title={t("Selecione um item da lista.")}
            required
            disabled={
              interview.availabilityAndConditions.availabilityCode !== "OH"
            }
          >
            <option key={0} value="0" selected disabled>
              {t("Notice...")}
            </option>
            {noticeList.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </Select>
        </div>
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="negotiable"
            name="negotiable"
            onChange={onChangeIsNegotiable}
            checked={interview.availabilityAndConditions.negotiable}
            disabled={
              interview.availabilityAndConditions.availabilityCode !== "OH"
            }
          />
          <label>{t("Negotiable?")}</label>
        </div>
      </div>
      <div className="form-check fixed-date">
        <input
          className="form-check-input"
          type="radio"
          name="availabilityId"
          id="FD"
          checked={
            interview.availabilityAndConditions.availabilityCode === "FD"
          }
          onChange={onChangeAvailability}
        />
        <label htmlFor="FD">
          {t("Fixed date")}
          {errors.fixedDate && (
            <span className="error-msg">{errors.fixedDate}</span>
          )}
        </label>
        <div className="training-date">
          <div className="form-group position-calendar">
            <Datetime
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              isValidDate={blockRetroactiveDates}
              value={getDateValid(
                interview.availabilityAndConditions.fixedDate
              )}
              onChange={onChangeFixedDate}
              closeOnSelect={true}
              utc={true}
              inputProps={{
                placeholder: t("dd-mm-yyyy"),
                disabled:
                  interview.availabilityAndConditions.availabilityCode !== "FD",
                id: "fixedDate"
              }}
              locale={
                i18n.language === "PT"
                  ? "PT"
                  : i18n.language === "FR"
                  ? "FR"
                  : "EN"
              }
              renderInput={(props) => {
                const clearField = () => {
                  props.onChange({ target: { value: "" } });
                };
                return (
                  <>
                    <input {...props} />
                    <button
                      ref={fixedDateButtonRef}
                      onClick={clearField}
                      style={{ display: "none" }}
                    />
                  </>
                );
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Availability;